import PreTripInspectionMissedStreaks from "../../components/Safety/PreTripInspectionCheck/PreTripInspectionMissedStreaks";

const PreTripInspectionMissedStreaksPage = () => {
  return <PreTripInspectionMissedStreaks />;
};

export default PreTripInspectionMissedStreaksPage;
